export const FIDELIDADE_DASHBOARD_LOADING = "FIDELIDADE_DASHBOARD_LOADING";
export const FIDELIDADE_DASHBOARD_TOTALIZADORES =
  "FIDELIDADE_DASHBOARD_TOTALIZADORES";
export const FIDELIDADE_DASHBOARD_GRAFICO_TRANSACOES =
  "FIDELIDADE_DASHBOARD_GRAFICO_TRANSACOES";
export const FIDELIDADE_DASHBOARD_COMPARATIVOS =
  "FIDELIDADE_DASHBOARD_COMPARATIVOS";
